module.exports = __webpack_public_path__ + "static/media/myra.81b25b06.gif";